import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=d66ce040&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=d66ce040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66ce040",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d66ce040')) {
      api.createRecord('d66ce040', component.options)
    } else {
      api.reload('d66ce040', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=d66ce040&scoped=true&", function () {
      api.rerender('d66ce040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UuS2KR37x3xe/JS/comp/PopupBox.vue"
export default component.exports